import React, { Component, Fragment } from "react";

import { AiOutlineFileImage, AiOutlineVideoCameraAdd, AiOutlineAppstoreAdd, AiFillDelete } from "react-icons/ai";
import { FaSpinner } from "react-icons/fa";

import * as Constant from "@app/Constant.js";

import axios from "@app/lib/axios";

import { AgGridReact } from "ag-grid-react";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";

class Account extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoaded: true,
            msg: "",
            id: this.props.id || 0,
            childs: this.props.childs || [],
        };
    }

    getAccount = () => {
        this.setState({ isLoaded: false, msg: "데이터 로딩 중입니다." }, () => {
            axios({
                method: "get",
                url: Constant.API_DOMAIN + `/api/tomoplay/parent/childs/${this.props.id}`,
            })
                .then((result) => {
                    console.debug(result);
                    if (result.data.code === 200) {
                        this.setState({
                            isLoaded: true,
                            childs: result.data.childs,
                        });
                    } else {
                        alert(result.data.msg);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                });
        });
    };

    defaultColDef = {
        headerClass: "bg-dark text-light",
    };

    listColumn = [
        {
            headerName: "No",
            field: "id",
            sortable: false,
            width: 60,
            resizable: true,
            cellClass: "text-center",
            filter: false,
        },
        {
            headerName: "원아명",
            field: "name",
            sortable: true,
            width: 120,
            resizable: true,
            cellClass: "text-center",
            filter: false,
        },
        {
            headerName: "생일",
            field: "birth",
            sortable: false,
            width: 110,
            resizable: true,
            cellClass: "text-center",
            filter: false,
        },
        {
            headerName: "부모계정",
            field: "p_user_id",
            sortable: true,
            width: 120,
            resizable: true,
            hide: true,
            cellClass: "text-center",
            filter: false,
        },
        {
            headerName: "원명",
            field: "class.nname",
            sortable: true,
            width: 120,
            resizable: true,
            cellClass: "text-center",
            filter: false,
        },
        {
            headerName: "반명",
            field: "class.cname",
            sortable: true,
            width: 120,
            resizable: true,
            cellClass: "text-center",
            filter: false,
        },
        {
            headerName: "원아코드",
            field: "code",
            sortable: true,
            width: 80,
            resizable: true,
            cellClass: "text-center",
            filter: false,
        },
        {
            headerName: "노트",
            field: "code",
            sortable: false,
            maxWidth: 60,
            resizable: true,
            cellClass: "text-center",
            filter: false,
            cellRenderer: (param) => {
                let result = "";
                if (param.data.class.tomonote_approval === "AP" && param.data.age) {
                    result = `${param.data.age + 2}세`;
                } else {
                    result = "-";
                }
                return result;
            },
        },
        {
            headerName: "momo",
            field: "code",
            sortable: false,
            maxWidth: 60,
            resizable: true,
            cellClass: "text-center",
            filter: false,
            cellRenderer: (param) => {
                let result = "";
                if (param.data.class.momo_approval === "AP" && param.data.age_momo) {
                    result = `${param.data.age_momo + 2}세`;
                } else {
                    result = "-";
                }
                return result;
            },
        },
        {
            headerName: "딩동",
            field: "code",
            sortable: false,
            maxWidth: 60,
            resizable: true,
            cellClass: "text-center",
            filter: false,
            cellRenderer: (param) => {
                let result = "";
                if (param.data.class.playdd_approval === "AP" && param.data.age_dd) {
                    result = `${param.data.age_dd + 2}세`;
                } else {
                    result = "-";
                }
                return result;
            },
        },
        {
            headerName: "젤링",
            field: "code",
            sortable: false,
            maxWidth: 60,
            resizable: true,
            cellClass: "text-center",
            filter: false,
            cellRenderer: (param) => {
                let result = "";
                if (param.data.class.jelliing_approval === "AP") {
                    result = `${param.data.class.jelliing_age + 2}세`;
                } else {
                    result = "-";
                }
                return result;
            },
        },
        {
            headerName: "별별",
            field: "code",
            sortable: false,
            maxWidth: 60,
            resizable: true,
            cellClass: "text-center",
            filter: false,
            cellRenderer: (param) => {
                let result = "";
                if (param.data.class.tomobooks_approval === "AP" && param.data.age_books) {
                    result = `${param.data.age_books + 2}세`;
                } else {
                    result = "-";
                }
                return result;
            },
        },
        {
            headerName: "계약",
            field: "code",
            sortable: false,
            minWidth: 350,
            resizable: true,
            cellClass: "text-center",
            filter: false,
            cellRenderer: (param) => {
                let result = "";

                if (param.data.class.tomonote_approval === "AP") {
                    result = "토모노트:계약(" + (param.data.class.age === 123 ? "혼합" : `${param.data.class.age + 2}세`) + ")";
                } else {
					result = "토모노트:계약없음";
				}
                if (param.data.class.momo_approval === "AP") {
                    result += "/momo:계약(" + (param.data.class.momo_age === 123 ? "혼합" : `${param.data.class.momo_age + 2}세`) + ")";
                } else {
					result += "/momo:계약없음";
				}
                if (param.data.class.playdd_approval === "AP") {
                    result += "/딩동:계약(" + (param.data.class.dd_age === 123 ? "혼합" : `${param.data.class.dd_age + 2}세`) + ")";
                } else {
					result += "/딩동:계약없음";
				}
                if (param.data.class.jelliing_approval === "AP") {
                    result += "/젤링:계약(" + (param.data.class.jelliing_age === 123 ? "혼합" : `${param.data.class.jelliing_age + 2}세`) + ")";
                } else {
					result += "/젤링:계약없음";
				}
                if (param.data.class.tomobooks_approval === "AP") {
                    result += "/별별책방:계약(" + (param.data.class.books_age === 123 ? "혼합" : `${param.data.class.books_age + 2}세`) + ")";
                } else {
					result += "/별별책방:계약없음";
				}
                return result;
            },
        },
        {
            headerName: "상태-토모플레이",
            field: "status",
            sortable: false,
            width: 110,
            resizable: true,
            cellClass: "text-center",
            filter: false,
            cellRenderer: (param) => {
                let result = "";
                if (param.data.retire_yn === "Y") {
                    result = "-";
                } else if (param.data.createDateTomoplay && !param.data.deleteDateTomoplay) {
                    if(param.data.p_user_id) {
                        if(param.data.parentStatus == 'deleted') {
                            result = "탈퇴";
                        } else if(param.data.agreeTomoplay || param.data.parentIsLegacy) {
                            result = "가입";
                        } else {
                            result = "-";
                        }
                    } else if(param.data.inviteDateTomoplay) {
                        result = "초대 O";
                    } else {
                        result = "초대 X";
                    }
                } else {
                    result = "등록 X";
                }
                return result;
            },
        },
        {
            headerName: "상태-젤링",
            field: "status",
            sortable: false,
            width: 110,
            resizable: true,
            cellClass: "text-center",
            filter: false,
            cellRenderer: (param) => {
                let result = "";
                if (param.data.retire_yn === "Y") {
                    result = "-";
                } else if (param.data.createDateJelliing && !param.data.deleteDateJelliing) {
                    if(param.data.p_user_id) {
                        if(param.data.parentStatus == 'deleted') {
                            result = "탈퇴";
                        } else if(param.data.agreeJelliing) {
                            result = "가입";
                        } else {
                            result = "-";
                        }
                    } else if(param.data.inviteDateJelliing) {
                        result = "초대 O";
                    } else {
                        result = "초대 X";
                    }
                } else {
                    result = "등록 X";
                }
                return result;
            },
        },
        {
            headerName: "퇴소",
            field: "status",
            sortable: false,
            width: 120,
            resizable: true,
			hide: true,
            cellClass: "text-center",
            filter: false,
            cellRenderer: (param) => {
                return param.data.retire_yn === "Y" ? param.data.statusChangeDate : "-";
            },
        },
    ];

    onGridReady = (params) => {
        this.gridApi = params.api;
        params.api.sizeColumnsToFit();
    };

    render() {
        if (this.state.isLoaded) {
            return (
                <Fragment>
                    <div className="row">
                        <div className="col-6">
                            <h5>원아 정보</h5>
                        </div>
                        <div className="col-6 text-right text-success bottom-right">* 초대 메시지를 다시 전송하는 경우 가입한 원아여도 초대 완료 상태로 변경됩니다.</div>
                    </div>
                    <div className="card border-top ag-theme-balham">
                        <div className="card-body" style={{ height: "185px", padding: "0px" }}>
                            <AgGridReact onGridReady={this.onGridReady} defaultColDef={this.defaultColDef} columnDefs={this.listColumn} rowData={this.state.childs} rowHeight={40} />
                        </div>
                    </div>
                </Fragment>
            );
        } else {
            return (
                <Fragment>
                    <div className="row">
                        <div className="col-6">
                            <h5>원아 정보</h5>
                        </div>
                        <div className="col-6 text-right text-success bottom-right">* 초대 메시지를 다시 전송하는 경우 가입한 원아여도 초대 완료 상태로 변경됩니다.</div>
                    </div>
                    <div className="card border-top">
                        <div className="card-body" style={{ height: this.props.height + "px", textAlign: "center", padding: "50px" }}>
                            <span className="dashboard-spinner spinner-xxl"></span>
                            <div style={{ marginTop: "15px" }}>
                                <p>{this.state.msg}</p>
                                <p>{this.state.uploading}</p>
                            </div>
                        </div>
                    </div>
                </Fragment>
            );
        }
    }
}

export default Account;
